import { render, staticRenderFns } from "./ViewOrderModal.vue?vue&type=template&id=b0076752&scoped=true&"
import script from "./ViewOrderModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderModal.vue?vue&type=style&index=0&id=b0076752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0076752",
  null
  
)

export default component.exports